export default __webpack_public_path__ + "static/media/butterfly.9f792e7f.ogg";